import React, { useCallback } from 'react';
import QuoteContext, { useQuoteContext } from '@/dataroom/application/landing/QuoteContext';
import FinalForm from '@/Framework/UI/Organisms/FinalForm';
import ReCaptcha from '@/Framework/UI/Molecules/Form/ReCaptcha';
import PhoneInput from '@dealroadshow/uikit/core/components/Input/PhoneInput';
import Clearfix from '@dealroadshow/uikit/core/components/Clearfix';
import Spinner from '@dealroadshow/uikit/core/components/Loader/Spinner';
import Textarea from '@dealroadshow/uikit/core/components/Textarea';
import Input from '@dealroadshow/uikit/core/components/Input';
import { CheckboxInput } from '@dealroadshow/uikit/core/components/Checkbox';
import Select from '@/Framework/UI/Molecules/Form/Select/legacy/ReduxFormSelect';
import QuoteFormSuccess from './QuoteFormSuccess';
import spacesStyles from '@dealroadshow/uikit/core/styles/helpers/spaces.scss';
import Button, { ButtonVariantType } from '@dealroadshow/uikit/core/components/Button';
import styles from './quoteForm.scss';
import validate from './validator';
import { dataroomProviderCollection } from './constants';
import { TFinalFormRenderProp } from '@/Framework/UI/Organisms/FinalForm/interfaces';

const QuoteForm = () => {
  const {
    isFetching,
    isSuccessScreen,
    getQuote,
  } = useQuoteContext();

  const renderForm: TFinalFormRenderProp = useCallback((props, {
    Field,
  }) => (
    <>
      <div className={ styles.activeDataroomsWrp }>
        <Field
          name="activeDatarooms"
          label="# of Active Data Rooms"
          placeholder="#"
          component={ Input }
          dataTest="quoteActiveDataroomsInput"
        />
      </div>
      <div className={ styles.currentDataroomProviderWrp }>
        <Field
          name="currentDataroomProvider"
          label="Current 17g5 Data Room Provider"
          // @ts-ignore
          component={ Select }
          options={ dataroomProviderCollection }
          simpleValue
          dataTest="currentDataroomProviderReduxFormSelect"
        />
      </div>
      <Clearfix />
      <Field
        name="company"
        label="Company"
        placeholder="Company Name"
        component={ Input }
        dataTest="quoteCompanyNameInput"
      />
      <div className={ styles.firstNameWrp }>
        <Field
          name="firstName"
          label="First name"
          placeholder="First Name"
          component={ Input }
          dataTest="quoteFirstNameInput"
        />
      </div>
      <div className={ styles.lastNameWrp }>
        <Field
          name="lastName"
          label="Last name"
          placeholder="Last Name"
          component={ Input }
          dataTest="quoteLastNameInput"
        />
      </div>
      <Clearfix />
      <Field
        name="email"
        label="Corporate email"
        placeholder="Email Address"
        component={ Input }
        dataTest="quoteCorporateEmailInput"
      />
      <Field
        name="phone"
        label="Phone Number"
        placeholder="Phone"
        isFinalForm
        component={ PhoneInput }
        dataTest="quotePhoneNumberInput"
      />
      <Field
        name="notes"
        label="Additional notes (OPTIONAL)"
        placeholder="Your notes..."
        component={ Textarea }
        rows={ 6 }
        dataTest="notesQuoteFormTextArea"
      />
      <Field
        name="callback"
        label="Request a call back from a 17g5.com specialist?"
        type="checkbox"
        className={ styles.checkbox }
        component={ CheckboxInput }
        isErrorMessage={ false }
        dataTest="requestCallCheckbox"
      />
      <div className={ styles.recaptchaWrp }>
        <Field
          name="recaptcha"
          component={ ReCaptcha }
        />
      </div>
      <div className={ styles.buttonWrp }>
        <Button
          variant={ ButtonVariantType.action }
          className={ spacesStyles.mrn }
          type="submit"
          title="Request Quote"
          dataTest="quoteFormSubmitButton"
        />
      </div>
    </>
  ), []);

  if (isSuccessScreen) {
    return <QuoteFormSuccess />;
  }

  return (
    <div className={ styles.formWrp }>
      <div className={ styles.form }>
        <Spinner
          isVisible={ isFetching }
          overlay
        />
        <FinalForm
          name="getQuoteForm"
          dataTest="getQuoteForm"
          onSubmit={ getQuote }
          render={ renderForm }
          validate={ validate }
        />
      </div>
    </div>
  );
};

export default () => (
  <QuoteContext>
    <QuoteForm />
  </QuoteContext>
);
